module.exports = __webpack_public_path__ + "img/sd_cla_1.a7bea2f3.png";